// test2686
(2686 && 0);
